var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "loading-content-container" },
    [
      _vm.loading
        ? _c(
            "div",
            {
              staticClass: "loading-overlay d-flex justify-content-center pt-5",
            },
            [_c("csp-loading-indicator")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading
        ? _c(
            "b-row",
            [
              _c(
                "csp-desktop-info-card",
                {
                  attrs: {
                    cols: 12,
                    icon: "inticon-users",
                    "show-buttons": false,
                    title: "Benutzerzuweisung",
                  },
                },
                [
                  _c("div", { staticClass: "mb-5" }, [
                    _c("h1", [
                      _vm._v(
                        "Benutzer in der Firmengruppe " +
                          _vm._s(_vm.firmGroupName)
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "\n                    Benutzer mit angehakter Checkbox erhalten Filialzugriff für die Filiale\n                    "
                      ),
                      _c("b", [_vm._v(_vm._s(_vm.currentFirmName))]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form",
                    {
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.submit.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "row" },
                        [
                          _c(
                            "div",
                            { staticClass: "col-md-3 mb-5" },
                            [
                              _c("h2", [_vm._v(_vm._s(_vm.currentFirmName))]),
                              _vm._v(" "),
                              _vm._l(
                                _vm.currentFirmUsers,
                                function (user, index) {
                                  return _c(
                                    "b-form-group",
                                    { key: "current-user-" + index },
                                    [
                                      _c(
                                        "b-form-checkbox",
                                        {
                                          attrs: {
                                            checked: true,
                                            disabled: "",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(user) +
                                              "\n                            "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                }
                              ),
                              _vm._v(" "),
                              _vm.currentFirmUsers.length === 0
                                ? _c("p", [
                                    _vm._v(
                                      "\n                            keine Benutzer vorhanden für diesen Stammbetrieb\n                        "
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.otherFirms, function (firm, firmIndex) {
                            return _c(
                              "div",
                              {
                                key: "firm-" + firmIndex,
                                staticClass: "col-md-3 mb-5",
                              },
                              [
                                _c("h2", [_vm._v(_vm._s(firm.firmName))]),
                                _vm._v(" "),
                                firm.users.length > 0
                                  ? _c(
                                      "div",
                                      { staticClass: "mb-2" },
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            attrs: { variant: "primary" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.checkAllUsersInFirm(
                                                  firmIndex
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                alle auswählen\n                            "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-button",
                                          {
                                            attrs: { variant: "primary" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.uncheckAllUsersInFirm(
                                                  firmIndex
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                alle abwählen\n                            "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(firm.users, function (user, userIndex) {
                                  return _c(
                                    "b-form-group",
                                    {
                                      key:
                                        "user-" + firmIndex + "-" + userIndex,
                                    },
                                    [
                                      _c(
                                        "b-form-checkbox",
                                        {
                                          attrs: { disabled: !_vm.canEdit },
                                          model: {
                                            value:
                                              _vm.assignmentsForm[
                                                String(user.userId)
                                              ],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.assignmentsForm,
                                                String(user.userId),
                                                $$v
                                              )
                                            },
                                            expression:
                                              "assignmentsForm[String(user.userId)]",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              class: user.highlight
                                                ? "firm-branch-user-assignment-highlight"
                                                : "",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(user.label) +
                                                  "\n                                "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                }),
                                _vm._v(" "),
                                firm.users.length === 0
                                  ? _c("p", [
                                      _vm._v(
                                        "\n                            keine Benutzer vorhanden für diesen Stammbetrieb\n                        "
                                      ),
                                    ])
                                  : _vm._e(),
                              ],
                              2
                            )
                          }),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.canEdit
                        ? _c(
                            "div",
                            { staticClass: "mt-3" },
                            [
                              _c("csp-form-group-btn-submit", {
                                attrs: {
                                  disable: !_vm.canEdit,
                                  "is-loading": _vm.saving,
                                },
                                on: { click: _vm.submit },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }